import {RoadKill} from "../RoadKill";
import {TimelineLite} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {RoadKillGameData} from "../server/RoadKillData";


export class RoadKillWinRunner implements SimplePresentation {
    private _mainTl: TimelineLite;

    public start(flowStateController: SimplePresentationRunnerController): void {
        const data: RoadKillGameData = RoadKill.model.gameData;
        this._mainTl = new TimelineLite();
        flowStateController.setSkipCallback(() => this.onSkip());
        if (data.brokeTheBank) {
            flowStateController.finish();
        }
        this._mainTl.add(RoadKill.initialWinView.playInitialWinAnimation());
        if (RoadKill.autoPlayPlugin.isAutoplayRound && RoadKill.model.winDataHighlight.length === 1) {
            this._mainTl.to(this,{duration : 1});//#319
        }
        this._mainTl.add(() => {
            RoadKill.initialWinView.resetIndividualSymWinViewCont();
            flowStateController.finish();
        });
    };

    public shouldRun(): boolean {
        return RoadKill.model.gameData.betWayWins.length > 0 && RoadKill.model.winRatio < 15 && !RoadKill.model.brokeTheBank;
    }

    private onSkip(): void {
        this._mainTl?.timeScale(10);
    }
}